/**
 * Formats an amount string to mirror Angular's `currency: 'USD' : 'symbol' : '0.0-2'`.
 * Includes the '$' symbol, thousands grouping, and a minimum of 0 / maximum of 2
 * fraction digits (`'1.0-2'` digitsInfo). Returns '$0' for invalid values.
 *
 * Handles null, undefined, and 'NaN' strings gracefully.
 *
 * Examples: 1234.5 -> '$1,234.5', 1234 -> '$1,234', 1234.567 -> '$1,234.57', 0 -> '$0'
 */
export function formatAmount(amount?: string | null): string {
  if (!amount || amount === 'NaN') return '$0.00';

  const num = parseFloat(amount);
  return (
    '$' +
    num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}
